import { useTranslations } from '@npco/utils-translations'
import { Box, NewBadge } from '@npco/zeller-design-system'

import { translationsShared } from 'translations'

type DesktopNewBadgeProps = {
  text?: string
}

export const DesktopNewBadge = ({ text }: DesktopNewBadgeProps) => {
  const tShared = useTranslations(translationsShared)

  return (
    <Box display={{ _: 'none', LG: 'block' }}>
      <NewBadge text={text ?? tShared('new')} />
    </Box>
  )
}
